import { render, staticRenderFns } from "./IncomingCallDialog.vue?vue&type=template&id=4c5c548c&scoped=true"
import script from "./IncomingCallDialog.vue?vue&type=script&lang=js"
export * from "./IncomingCallDialog.vue?vue&type=script&lang=js"
import style0 from "./IncomingCallDialog.vue?vue&type=style&index=0&id=4c5c548c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5c548c",
  null
  
)

export default component.exports